import { render } from "./GuardianStep.vue?vue&type=template&id=fef71c26"
import script from "./GuardianStep.vue?vue&type=script&lang=js"
export * from "./GuardianStep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__